import { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { signIn } from 'store/auth/actions'
import { getCookie } from 'libraries/cookie'
import { RoutesWrapper } from 'libraries/router'
import { Footer, Header } from 'components/molecules'
import { getNewProducts,getProducts } from 'store/product/actions'
import { useAppDispatch, useAppSelector } from 'libraries/redux'
import { getBasket, getInformations, getWishlist } from 'store/wishlist/actions'
import { getStore, getCategories } from 'store/category/actions'
import { CategoriesSelectors } from 'store/category/selectors'

const ScrollToTop = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [location])

  return null
}

const PageLayout: FC = () => {
  const token = getCookie('token')
  const dispatch = useAppDispatch()
  const { data: storeInfo } = useAppSelector(CategoriesSelectors.storeInfo)


  const getProductsList = () =>{
    dispatch(
        getProducts({
          page: 1,
          per_page: 4,
          core_filter: '',
          filter_has_special: false,
          category_filter: [Number(process.env.REACT_APP_CATEGORY_ID)],
          price_to: '',
          price_from: '',
        })
    )
  }
  const getCategoriesList = () => {
    dispatch(getCategories(process.env.REACT_APP_CATEGORY_ID))
  }

  const getNewProductsList = (id:any) => {
    dispatch(getNewProducts(id))
  }

  const getWishlistInfo = () => {
    dispatch(getWishlist())
  }

  const getBasketInfo = () => {
    dispatch(getBasket())
  }

  const getStoreInfo = () => {
    dispatch(getStore())
  }

  const getInformationsInfo = () => {
    dispatch(getInformations())
  }

  useEffect(() => {
    getStoreInfo()
    getCategoriesList()
    getWishlistInfo()
    getBasketInfo()
    getInformationsInfo()

    if (!token) {
      dispatch(signIn())
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(storeInfo?.category?.id){
      getNewProductsList(storeInfo.category.id)
    }else {
      getNewProductsList(process.env.REACT_APP_CATEGORY_ID)

    }
  }, [storeInfo]);

  useEffect(() => {
    getProductsList()
  }, []);

  useEffect(() => {
    const descriptionMetaTag = document.querySelector('meta[name="description"]')
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute('content', `Интернет магазин ${storeInfo?.name} `)
    }
    if (storeInfo?.fb_pixel_id) {
      const fbScript = document.createElement('script')

      fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', ${storeInfo.fb_pixel_id});
      fbq('track', 'PageView');
    `

      const noscriptImg = document.createElement('noscript')
      noscriptImg.innerHTML = `
      <img height="1" width="1" style="display:none" 
           src="https://www.facebook.com/tr?id=${storeInfo.fb_pixel_id}&ev=PageView&noscript=1"/>
    `

      document.head.appendChild(fbScript)
      document.body.appendChild(noscriptImg)
    }

    if (storeInfo?.ga_tracking_id) {
      const gmScript = document.createElement('script')

      gmScript.src = `https://www.googletagmanager.com/gtag/js?id=${storeInfo?.ga_tracking_id}`

      gmScript.async = true

      document.head.appendChild(gmScript)

      const gaScript = document.createElement('script')

      gaScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() {window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${storeInfo.ga_tracking_id}');
`

      document.head.appendChild(gaScript)
    }
  }, [storeInfo])

  return (
    <>
      <Header />
      <main>
        <ScrollToTop />
        <RoutesWrapper />
      </main>
      <Footer />
    </>
  )
}

export default PageLayout
